<dashboardnav>
    <cradua-documenttypecode
    [documenttypecodes]="documenttypecodes$ | async"
    (documenttypecode)="onSubmitDocumentTypeCode($event)"
    (deleteDocumentTypeCodeEvent)="onDeleteDocumentTypeCode($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-documenttypecode>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  